"use strict";
exports.__esModule = true;
exports.Table = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../../utils/helpers/class-names"));
var Table = function (_a) {
    var children = _a.children, className = _a.className, rest = tslib_1.__rest(_a, ["children", "className"]);
    return (react_1["default"].createElement("table", tslib_1.__assign({ dir: "rtl", className: (0, class_names_1["default"])('w-full', className) }, rest), children));
};
exports.Table = Table;
exports["default"] = exports.Table;
//# sourceMappingURL=table.js.map